/**
 * Curated set of the most commonly used Pipedream apps, shared by the "Connect an app" dialog and the
 * trigger app picker. Intentionally hardcoded (not fetched) so popular apps appear instantly and
 * stably without a network round-trip. Shape matches the picker's option shape: `nameSlug` drives the
 * downstream flow, with `name`/`imgSrc` for display.
 */
const POPULAR_APPS = [
  { nameSlug: 'gmail', name: 'Gmail', imgSrc: 'https://assets.pipedream.net/s.v0/app_OQYhq7/logo/orig' },
  { nameSlug: 'slack_v2', name: 'Slack', imgSrc: 'https://assets.pipedream.net/s.v0/app_M0hv7G/logo/orig' },
  { nameSlug: 'google_sheets', name: 'Google Sheets', imgSrc: 'https://assets.pipedream.net/s.v0/app_168hvn/logo/orig' },
  { nameSlug: 'notion', name: 'Notion', imgSrc: 'https://assets.pipedream.net/s.v0/app_X7Lhxr/logo/orig' },
  { nameSlug: 'airtable_oauth', name: 'Airtable', imgSrc: 'https://assets.pipedream.net/s.v0/app_XBxhAl/logo/orig' },
  { nameSlug: 'hubspot', name: 'HubSpot', imgSrc: 'https://assets.pipedream.net/s.v0/app_OkrhlP/logo/orig' },
  { nameSlug: 'salesforce_rest_api', name: 'Salesforce', imgSrc: 'https://assets.pipedream.net/s.v0/app_OrZhD7/logo/orig' },
  { nameSlug: 'google_calendar', name: 'Google Calendar', imgSrc: 'https://assets.pipedream.net/s.v0/app_13Gh2V/logo/orig' },
  { nameSlug: 'microsoft_outlook', name: 'Outlook', imgSrc: 'https://assets.pipedream.net/s.v0/app_XbPhEP/logo/orig' },
];

export default POPULAR_APPS;
